import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.companies;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const companySelector = createSelector(
    selectFeature, 
    (state) => state.companies
);

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);